<template>
  <div class="cart-item border-b border-solid border-gray-550">
    <div class="flex flex-row space-x-0 lg:space-x-8 gap-2">
      <div class="flex-initial w-1/3 lg:min-w-max">
        <img :src="image" class="product__image" />
      </div>
      <div class="flex-1 w-auto flex flex-col">
        <template v-if="isValid">
          <div class="cart-item__description">{{ data.product_name }}</div>
          <div class="text-sm lg:text-lg mt-2 break-all" v-if="data.sku_item_parent_name_1">
            <span class="font-bold">{{ data.sku_item_parent_name_1 }}</span
            >:
            <span class="ml-2">{{ data.sku_set_item_name1 }}</span>
          </div>
          <div class="text-sm lg:text-lg mt-2 break-all" v-if="data.sku_item_parent_name_2">
            <span class="font-bold">{{ data.sku_item_parent_name_2 }}</span
            >:
            <span class="ml-2">{{ data.sku_set_item_name2 }}</span>
          </div>
          <div class="cart-item__wrap my-4">
            <div class="cart-item__price">
              <span>{{ $t('cartList.item.unitPrice') }}</span>
              <span class="font-light text-xxs">{{ $t('cartList.item.withTax') }}</span>
              <span>{{ $t('cartList.item.separatorColon') }}</span>
              {{ $n(isSubscription ? data.price03_after_tax : data.price02_after_tax, 'currency', 'ja-JP') }}
            </div>
            <div class="cart-item__quantity ml-1">
              <span class="text-red whitespace-pre-line text-center" v-if="data.is_out_stock">{{
                $t('ec-line003.content.outOfStock')
              }}</span>
              <el-form-item
                v-else-if="isSubscription"
                :prop="'subscriptionCarts.' + index + '.quantity'"
                :rules="rules"
              >
                <base-input-number
                  :value="data.quantity"
                  :max-value="data.sale_limit"
                  :min-value="1"
                  @input="onChange"
                ></base-input-number>
              </el-form-item>
              <el-form-item v-else :prop="'normalCarts.' + index + '.quantity'" :rules="rules">
                <base-input-number
                  :value="data.quantity"
                  :max-value="data.sale_limit"
                  :min-value="1"
                  @input="onChange"
                ></base-input-number>
              </el-form-item>
            </div>
          </div>
          <div class="cart-item__total">
            <span>{{ $t('cartList.item.subtotal') }}</span>
            <span class="font-light text-xxs">{{ $t('cartList.item.withTax') }}</span>
            <span>{{ $t('cartList.item.separatorColon') }}</span>
            {{
              $n(
                isSubscription ? data.product_subtotal_price03_after_tax : data.product_subtotal_price02_after_tax,
                'currency',
                'ja-JP'
              )
            }}
          </div>
          <div v-if="hasDiscountAmount" class="text-xs">
            <span> {{ $t('common.label.priceDiscount') }}</span>
            <span>{{ $t('cartList.item.separatorColon') }}</span>
            <span class="text-red">{{ $n(data.product_subtotal_discount_amount, 'currency', 'ja-JP') }}</span>
          </div>
          <div class="flex">
            <el-button class="ml-auto text-gray-150 py-0 my-2 font-normal" type="text" @click="removeItem(data)">{{
              $t('common.action.delete')
            }}</el-button>
          </div>
        </template>
        <template v-else-if="data.visible === false">
          <div class="cart-item__description">{{ $t('ec-line003.content.errorType2') }}</div>
        </template>
        <template v-else>
          <div class="cart-item__description">{{ $t('ec-line003.content.errorType1') }}</div>
        </template>
      </div>
    </div>
    <el-row v-if="data.is_product_sku_valid === false">
      <el-col :span="24" class="text-center mt-9 mb-10">
        <el-button class="secondary-btn ec-line003__secondary-btn" @click="toDetailPage">{{
          $t('ec-line003.content.checkProductDetailBtn')
        }}</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import BaseInputNumber from '@/components/BaseInputNumber.vue'
export default {
  components: { BaseInputNumber },
  props: {
    data: { type: Object, required: true, default: () => {} },
    isSubscription: { type: Boolean, default: false },
    index: {
      type: Number,
      default: null,
    },
  },
  data() {
    const mappingMaxValue = (rule, value, callback) => {
      if (this.data.sale_limit && value > this.data.sale_limit) {
        callback(new Error(this.$t('common.cart.maxInputNumber', { val: this.data.sale_limit })))
      }

      callback()
    }
    return {
      rules: [
        {
          validator: mappingMaxValue,
          trigger: ['change', 'blur'],
        },
      ],
    }
  },
  computed: {
    image() {
      return this.isValid ? this.data.product_image : require('@/assets/images/gray-image.svg')
    },
    isValid() {
      return (
        this.data.visible &&
        [undefined, true].includes(this.data.is_product_sku_valid) &&
        this.data.is_out_stock === false
      )
    },
    subTotal() {
      return this.Utils.helper.subTotal(this.data.price, this.data.quantity)
    },
    hasDiscountAmount() {
      return this.data.product_subtotal_discount_amount && Number(this.data.product_subtotal_discount_amount) < 0
    },
  },
  methods: {
    removeItem(data) {
      this.$emit('remove', { id: data.id, subscription: this.isSubscription })
    },
    toDetailPage() {
      this.$router.push({ name: 'EC_LINE002', params: { id: this.data.product_id } })
    },
    onChange(val) {
      if (this.data.sale_limit && val > this.data.sale_limit) {
        this.handleError({
          message: this.$t('common.cart.saleLimitToast', {
            name: this.data.product_name,
            saleLimit: this.data.sale_limit,
          }),
        })
      }
      this.$emit('update-quantity', {
        id: this.data.id,
        quantity: val,
        subscription: Number(this.isSubscription),
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/cart-list-item.scss';
</style>
